import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, TextField } from '../../../../ui';
import { useApi } from '../../../../hooks';
import { useAsync } from '../../../../hooks/useAsync';

export const UnderwriterNotes = ({ quote }) => {
  const [description, setDescription] = useState(quote?.description || '');
  const { addDescriptionForQuoteWithId } = useApi();

  useEffect(() => {
    setDescription(quote?.description || '');
  }, [quote?.description]);

  const saveDescription = useCallback(
    async (val) => {
      await addDescriptionForQuoteWithId(quote.id, val);
    },
    [addDescriptionForQuoteWithId, quote.id]
  );

  const { execute, status } = useAsync(saveDescription, { immediate: false });
  const loading = status === 'pending';

  return (
    <Box padding={24}>
      <TextField
        InputProps={{ multiline: true }}
        multiline
        height={300}
        width="100%"
        maxWidth="100%"
        value={description}
        disabled={loading}
        onChangeValue={setDescription}
        placeholder="Enter underwriting notes..."
      />
      <Box marginTop={16} display="flex" justifyContent="flex-start">
        <Box alignSelf="flex-start">
          <Button
            label="Save"
            size="medium"
            onPress={() => execute(description)}
            loading={loading}
            disabled={loading || !description.trim()}
            color={!description ? '$gray.500' : '$primary'}
          />
        </Box>
      </Box>
    </Box>
  );
};
